import React from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import "./RevenuePie.css"; // Ensure this file exists

const data = [
  { name: "Wafer", value: 60.2, color: "#4f8ef7" }, // Blue
  { name: "Others", value: 8.9, color: "#a9a9a9" }, // Gray
];

const RevenuePie = () => {
  const renderLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    name,
    value,
  }) => {
    const radius = outerRadius + 20; // Position labels outside the pie chart
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize={12}
      >
        {`${name}: $${value}B`}
      </text>
    );
  };

  return (
    <div className="revenue-container">
      <h3>2023-12 Operating Revenue by Business Segment</h3>
      <PieChart width={500} height={500} style={{ margin: "auto" }}>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={100}
          outerRadius={140}
          fill="#8884d8"
          paddingAngle={2}
          label={renderLabel}
          labelLine
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value, name) => [`$${value}B`, name]}
          wrapperStyle={{ zIndex: 5 }}
        />
        <Legend
          layout="horizontal"
          verticalAlign="bottom"
          align="center"
          formatter={(value) => <span style={{ color: "#000" }}>{value}</span>}
        />
      </PieChart>
      {/* Centered image */}
      <div className="centered-image">
        <img
          src="https://t3.ftcdn.net/jpg/05/18/90/34/360_F_518903495_sbH9seaoW75wyjemo2CHDQm39jHXOcBi.jpg"
          alt="TSMC"
        />
      </div>
    </div>
  );
};

export default RevenuePie;
